<div id="exceptions" class="tab-pane fade in active">
    <h3 style="text-align:center;">Add New Exception</h3>
    <br />
    
        
    <div class= "center">
        <input id="inputVal" [(ngModel)]="ExceptionName" name="ExceptionName" type="text" placeholder="Enter the exception text here" 
        style="padding:15px;width:30%;background-color:#F9f9f9 !important;border:none;" />
        <button id="btnAdd" (click)="ExceptionCreate()" type="button" class="btn btn-lg btn-primary buttonStyle" 
        style="text-align:center;margin-left:40px;">Add as an exception</button>
    </div>

    <p class="alert alert-danger"  id="successMessage"  *ngIf =  "result.WordError != null">
        <i class="fa fa-exclamation-triangle"  aria-hidden="true"></i> {{result.WordError}}
    </p>




    <br />
    <br />
    <div id="TextBoxContainer" style="border:2px #808080; background-color:#eae7e7;padding:20px;">
        <h4 id="addExceptions" style="color:#808080;">

        <b><div class= "center" *ngIf="NoWords == null">No Exceptions Added !</div></b>
        </h4>
        <!-- exceptions will be added here -->
        <div *ngFor="let eachExeption of exceptionlist">
            <div class="DynamicBox" style="display:inline-block;border:2px #F9f9f9; box-sizing: border-box; 
            background-color:white;padding:10px;margin-left:20px;margin-bottom:15px;width:200px;text-align:center;">
            <span (click)="exceptionDelete(eachExeption)" id="close" class="remove" style="color:white !important;"><b>x</b></span>
                {{eachExeption.Word}}
            </div>
        </div>
        
        
    </div>
    <br />
    <br />

</div>